import { render, staticRenderFns } from "./ib-table-col.vue?vue&type=template&id=477582fe&lang=pug&"
import script from "./ib-table-col.vue?vue&type=script&lang=js&"
export * from "./ib-table-col.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev39a/aleggett/thgit/web.app/lib.common/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('477582fe')) {
      api.createRecord('477582fe', component.options)
    } else {
      api.reload('477582fe', component.options)
    }
    module.hot.accept("./ib-table-col.vue?vue&type=template&id=477582fe&lang=pug&", function () {
      api.rerender('477582fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table/ib-table-col.vue"
export default component.exports